import type { TmWrappers } from '@/wrappers'
import type { Forms } from '@/services/forms/formTypes'
import type { RegisteredServices } from '@/core/container/types'

export enum PointAiResourceType {
  WEBSITE = 'link',
  WEBSITE_DOWNLOADED = 'subLink',
  DOCUMENT = 'file',
}

export enum PointAiDocumentsFormFields {
  FILE = 'file',
}

export enum PointAiAssistantStatus {
  READY = 'ready',
  SYNCHRONIZING = 'synchronizing',
  EMPTY = 'empty',
  DELETED = 'deleted',
}

export enum PointAiWebsiteStatus {
  PENDING = 'pending',
  SYNCHRONIZING = 'synchronizing',
  SYNCHRONIZED = 'synchronized',
  ERROR = 'error',
  DELETING = 'deleting',
}

export enum PointAiWebsiteDownloadedStatus {
  ACTIVE = 'active',
  PROCESSING = 'processing',
  DELETED = 'deleted',
  ERROR = 'error',
}

export type PointAiDocumentFormScheme = {
  [PointAiDocumentsFormFields.FILE]: File
}

export const pointAiAttachmentModalId: TmWrappers = 'pointAiAttachmentModal'
export const pointAiAttachmentModalIdWebsite: TmWrappers = 'pointAiAttachmentModalWebsite'
export const pointAiAttachmentModalIdDocument: TmWrappers = 'pointAiAttachmentModalDocument'

export const pointAiWebsitesFormId: Forms = 'PointAiWebsitesFormService'
export const pointAiDocumentsFormId: Forms = 'PointAiDocumentsFormService'

export const pointAiWebsitesTableId = 'pointAiWebsitesTable' as RegisteredServices
export const pointAiDocumentsTableId = 'pointAiDocumentsTable' as RegisteredServices
export const pointAiDocumentsListId = 'pointAiDocumentsList' as RegisteredServices
export const pointAiWebsitesDownloadedTableId = 'pointAiWebsitesDownloadedTable' as RegisteredServices

export const pointAiLearnMoreLink =
  'https://support.textmagic.com/article/use-point-ai-for-smarter-replies-based-on-your-knowledge-base'
